// Constants
export const notas_pendientes = () => {
  return {
    notas_pendientes: {      
      id: {
        namepath: ['aportes_pendientes'],
        description: 'id autoincrement',
        label: 'Id',
        readonly: true,
        type: 'number',
        datatype: 
        {
          predeterminate: null
        }
      },
      id_datos_afiliado: {
        namepath: ['aportes_pendientes','aportes_registrar'],
        type: 'text',
        label: 'Nombre del referidor',
        placeholder: '',
        description: 'Nombre del check', 
        validate: 'required',
        datatype: { 
          type: 'input', 
          disabled: false,
          predeterminate: null,
        }   
      }, 
      id_info_afiliacion: {
        namepath: ['aportes_pendientes'],
        type: 'text',
        label: 'Nombre del referidor',
        placeholder: '',
        description: 'Nombre del check', 
        validate: 'required',
        datatype: { 
          type: 'input', 
          disabled: false,
          predeterminate: null,
        }   
      }, 
      id_datos_razon: {
        namepath: ['aportes_pendientes'],
        type: 'text',
        label: 'Nombre de la razón',
        placeholder: '',
        description: 'Nombre del check', 
        validate: 'required',
        datatype: { 
          type: 'input', 
          disabled: false,
          predeterminate: null,
        }   
      }, 
      id_list_mes: {
        namepath: ['aportes_pendientes'],
        type: 'text',
        label: 'Nombre de la razón',
        placeholder: '',
        description: 'Nombre del check', 
        validate: 'required',
        datatype: { 
          type: 'input', 
          disabled: false,
          predeterminate: null,
        }   
      },  
      id_list_ano: {
        namepath: ['aportes_pendientes'],
        type: 'text',
        label: 'Nombre de la razón',
        placeholder: '',
        description: 'Nombre del check', 
        validate: 'required',
        datatype: { 
          type: 'input', 
          disabled: false,
          predeterminate: null,
        }   
      }, 
      nota: {
        namepath: ['aportes_pendientes'],
        type: 'text',
        label: 'Nota',
        placeholder: '',
        description: 'Nota', 
        validate: 'required',
        datatype: { 
          type: 'input', 
          disabled: false,
          predeterminate: null,
        }   
      },       
      nota_delete: {
        type: "text",
        label: "Nota",
        placeholder: "",
        namepath: ['aportes_pendientes'],
        description: "",
        validate: "required",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: null
        }
      },     
      deleted_at: {
        type: "text",
        label: "Eliminar",
        placeholder: "",
        namepath: ['aportes_pendientes'],
        description: "",
        validate: "required",
        datatype: {
          type: "input",
          disabled: false,
          predeterminate: null
        }
      },
    }
  }
}
